import React from 'react';
//MetricsDisplay.jsx in components/common/MetricsDisplay.jsx
const MetricsDisplay = ({ metrics }) => {
  if (!metrics || Object.keys(metrics).length === 0) return null;
  
  return (
    <div className="flex justify-around gap-2 pt-4 border-t border-accent-green/20">
      {Object.entries(metrics).map(([key, value]) => (
        <div key={key} className="flex flex-col items-center group">
          <div className="text-xs uppercase font-bold text-accent-golden mb-1 tracking-wider group-hover:text-accent-green transition-colors duration-300">
            {key}
          </div>
          <div className="text-lg font-bold text-text-light bg-accent-green/10 px-3 py-1 rounded-lg border border-accent-green/30">
            {value}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsDisplay;